export class Formats {
  public static readonly CURRENCY: string = '1.2-2';
  public static readonly PERCENT: string = '1.2-2';
}
